import { THEME_MODE } from "./constants";

export const changeTheme = (flag) => async (dispatch) => {
  dispatch({
    type: THEME_MODE,
    payload: flag,
  });
};
